import React, {useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import {Navigate, useLocation} from "react-router-dom"
import {logout} from "../component/redux/reducers/authReducer";

const NormalRoute = ({children}) => {
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const dispatch = useDispatch();
    const isExp = useSelector(state => state.auth.exp);
    let location = useLocation();

    useEffect(() => {
        if (isExp * 1000 < Date.now()) {
            logout();
            dispatch(logout());
        }
    }, [dispatch, isExp]);

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{from: location}} replace/>
    }
    return children

};

export default NormalRoute;